import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface OrderModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const OrderModal = ({ isOpen, onClose }: OrderModalProps) => {
  const orderLinks = {
    zomato: "https://www.zomato.com/ncr/curious-mug-amrapali-leisure-valley-greater-noida",
    swiggy: "https://www.swiggy.com/city/noida/curious-mug-sector-1-amrapali-leisure-valley-rest515122",
    magicpin: "https://magicpin.in/Greater-Noida/Amrapali-Leisure-Valley/Restaurant/Curious-Mug/store/9438c1/",
  };

  const handleOrder = (platform: keyof typeof orderLinks) => {
    window.open(orderLinks[platform], "_blank");
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-2xl">Order from Curious Mug</DialogTitle>
          <DialogDescription>
            Choose your preferred delivery platform to place your order
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4 py-4">
          <Button
            onClick={() => handleOrder("zomato")}
            className="w-full h-14 text-lg bg-destructive hover:bg-destructive/90"
            size="lg"
          >
            <span className="font-semibold">Order via Zomato</span>
          </Button>
          
          <Button
            onClick={() => handleOrder("swiggy")}
            className="w-full h-14 text-lg bg-accent hover:bg-accent/90"
            size="lg"
          >
            <span className="font-semibold">Order via Swiggy</span>
          </Button>
          
          <Button
            onClick={() => handleOrder("magicpin")}
            className="w-full h-14 text-lg"
            size="lg"
          >
            <span className="font-semibold">Order via Magicpin</span>
          </Button>
        </div>

        <p className="text-sm text-muted-foreground text-center">
          You'll be redirected to the selected platform to complete your order
        </p>
      </DialogContent>
    </Dialog>
  );
};

export default OrderModal;
